// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7e24546e","453":"a88d4c9a"}[chunkId] + ".chunk.js";
};